import React, { useState } from "react";
import SkipNextIcon from "@material-ui/icons/SkipNext";
import SkipPreviousIcon from "@material-ui/icons/SkipPrevious";
import { InlineMath } from "react-katex";
const Chtambahan = ({ukuranH,ukuranP}) => {
	const [show1, setShow1] = useState(false);
	const [show2, setShow2] = useState(false);
	const [show3, setShow3] = useState(false);
	const [show4, setShow4] = useState(false);
	const [show5, setShow5] = useState(false);

	return (
		<div
			style={{
				margin: "auto",
				lineHeight: "35px",
				textAlign: "justify",
				width: "100%",
				borderStyle: "solid",
				borderColor: "#2d8659",
				borderRadius: "25px",
				boxShadow: "5px 5px #888887",
			}}
			className="container mb-2 mt-2"
		>
			<div
				style={{
					width: "80%",
					margin: "auto",
				}}
			>
				<p
					style={{
						textIndent: "2rem",
						width: "100%",
						textAlign: "justify",
						lineHeight: "35px",
						fontSize:`${ukuranP}px`
					}}
				>
					Seorang pengusaha mebel akan memproduksi meja dan kursi yang
					menggunakan bahan dari papan-papan kayu dengan ukuran tertentu. Satu
					meja memerlukan bahan 10 potong dan satu kursi memerlukan 5 potong
					papan. Papan yang tersedia ada 500 potong. Biaya pembuatan satu meja
					Rp100.000,00 dan biaya pembuatan satu kursi Rp40.000,00. Anggaran yang
					tersedia Rp1.000.000,00. Model matematika dari persoalan tersebut
					adalah ....
				</p>
			</div>
			<div
				style={{
					color: "green",
					display: "flex",
					justifyContent: "space-between",
					width: "10%",
				}}
			>
				<div
					style={{
						width: "5px",
						height: "5px",
						animation: "scrollTop 0.3s alternate ease infinite",
					}}
				>
					<SkipNextIcon />
				</div>
				<p style={{ marginLeft: "22px", cursor: "pointer" }}>
					<strong>
						<u>Jawaban</u>
					</strong>
				</p>
				<div
					style={{
						width: "5px",
						height: "5px",
						animation: "scrollTop 0.2s alternate ease infinite",
					}}
				>
					<SkipPreviousIcon />
				</div>
			</div>
			<div
				style={{
					margin: "auto",
					width: "80%",
					position: "relative",
					textAlign: "justify",
				}}
			>
				<ol style={{fontSize:`${ukuranP}px`}}>
					<li>
						Pertama kita buat tabel, agar memudahkan kita dalam menyusun model
						matematikanya!
					</li>
					
						<button
							className="btn btn-success btn-sm mb-2"
							onClick={() => setShow1(true)}
						>
							Lanjut
						</button>
				
					{show1 ? (
						<>
							<table
								className="table"
								style={{
									border: "2px solid green",
									borderCollapse: "collapse",
									width: "100%",
									textAlign: "center",
								}}
							>
								<tr>
									<th
										scope="col"
										style={{
											border: "2px solid green",
										}}
									>
										Pembatas
									</th>
									<th
										scope="col"
										style={{
											border: "2px solid green",
										}}
									>
										Meja
									</th>
									<th
										scope="col"
										style={{
											border: "2px solid green",
										}}
									>
										Kursi
									</th>
									<th
										style={{
											border: "2px solid green",
										}}
									>
										Persediaan
									</th>
									<th
										style={{
											border: "2px solid green",
										}}
									>
										Satuan
									</th>
								</tr>

								<tr>
									<td
										style={{
											border: "2px solid green",
										}}
									>
										Papan
									</td>
									<td
										style={{
											border: "2px solid green",
										}}
									>
										10
									</td>
									<td
										style={{
											border: "2px solid green",
										}}
									>
										5
									</td>
									<td
										style={{
											border: "2px solid green",
										}}
									>
										500
									</td>
									<td
										style={{
											border: "2px solid green",
										}}
									>
										Potong
									</td>
								</tr>

								<tr>
									<td
										style={{
											border: "2px solid green",
										}}
									>
										Modal
									</td>
									<td
										style={{
											border: "2px solid green",
										}}
									>
										100.000
									</td>
									<td
										style={{
											border: "2px solid green",
										}}
									>
										40.000
									</td>
									<td
										style={{
											border: "2px solid green",
										}}
									>
										1.000.000
									</td>
									<td
										style={{
											border: "2px solid green",
										}}
									>
										Rupiah
									</td>
								</tr>
							</table>
					
								<button
									className="btn btn-success btn-sm mt-2 mb-2"
									onClick={() => setShow2(true)}
								>
									Lanjut
								</button>
						
							{show2 ? (
								<>
									<li>
										<p>Dengan memisalkan :</p>
										<ul>
											<li>
												<i>x</i> = banyaknya meja
											</li>
											<li>
												<i>y</i> = banyaknya kursi
											</li>
										</ul>
									</li>
									<button
										className="btn btn-success btn-sm mt-2 mb-2"
										onClick={() => setShow3(true)}
									>
										Lanjut
									</button>
									{show3 ? (
										<>
											<li>
												<p>Maka,</p>
												<p>
													Peggunaan bahan papan :{" "}
												</p>
												<p>
													
														
													<InlineMath math="\iff"/><b>10x + 5y ≤ 500</b>{" "}
													
												</p>
												<p><InlineMath math="\iff"/> Disederhanakan menjadi :</p>
											
													<p>
													<InlineMath math="\iff"/>	<b>2x + y ≤ 100</b>
													</p>
												<p className="alert alert-warning fst-italic">Dan didapatkan satu pertidaksamaan</p>
												<p>
													Peggunaan dana modal :
													
												</p>
												<p>
												<i>
													<InlineMath math="\iff"/> <b>100.000x + 40.000y ≤ 1.000.000 </b>{" "}
													</i>{" "}
												</p>
												<p><InlineMath math="\iff"/> Disederhanakan menjadi :</p>
												<p>
													<InlineMath math="\iff"/> <b>5x + 2y ≤ 50</b>
													
												</p>
												<p className="alert alert-warning fst-italic">Dan kalian sudah mendapatkan dua pertidaksamaan</p>
											</li>
											<button
												className="btn btn-success btn-sm mt-2 mb-2"
												onClick={() => setShow4(true)}
											>
												Lanjut
											</button>
											{show4 ? (
												<>
													<li>
														Karena tidak mungkin banyaknya meja dan kursi itu negatif, sehingga dapat
														dituliskan &nbsp;&nbsp;
														<b>
															<i>x ≥ 0</i>
														</b>&nbsp;&nbsp;
														dan&nbsp;&nbsp;
														<b>
															<i>y ≥ 0</i>
														</b>
													</li>
													<button
														className="btn btn-success btn-sm mt-2 mb-2"
														onClick={() => setShow5(true)}
													>
														Lanjut
													</button>
													{show5 ? (
														<>
															<li>Maka model matematikanya adalah</li>
															<div className="text-center mt-1">
																<InlineMath math=" 2x + y ≤ 100 ; " />
																&nbsp;&nbsp;<InlineMath math=" 5x + 2y ≤ 50 ; " />
																&nbsp;&nbsp;<InlineMath math=" x ≥ 0 ; y ≥ 0" />
															</div>
														</>
													) : null}
												</>
											) : null}
										</>
									) : null}
								</>
							) : null}
						</>
					) : null}
				</ol>
			</div>
		</div>
	);
};

export default Chtambahan;
